import { CaretLeftIcon } from '../../../icon/icons/caret-left';
import { CaretRightIcon } from '../../../icon/icons/caret-right';
import { IconButton } from '../../icon-button/icon-button.component';
import { WeekNavType } from '../types';

type NavigateProps = {
  onClick: (type: WeekNavType) => void;
  type: WeekNavType;
};

export const Navigate = ({ onClick, type }: NavigateProps) => (
  <IconButton
    label={type === 'previous' ? 'Previous Week' : 'Next Week'}
    onClick={() => onClick(type)}
    showLabelOnHover
  >
    {type === 'previous' ? <CaretLeftIcon /> : <CaretRightIcon />}
  </IconButton>
);
